interface AnalyticsManagerWindow extends Window {
  OneTrust?: any;
  OnetrustActiveGroups?: string;
  // Gainsight
  aptrinsic?: any;
}
// Add additional properties used in Cookie consent and Analytics to `window`.
// Use this `amWindow` in AnalyticsManager code in place of `window` so that we don't need to
// worry about changing type definition outside of analyticsManager folder.
export const amWindow = window as AnalyticsManagerWindow;

export type TrackingVendor = 'mixpanel' | 'gainsight' | 'all';

export interface TrackPayload {
  event: string;
  params?: {};
  vendor?: TrackingVendor;
}

export interface UserIdentifier {
  [key: string]: any;
}
